var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      ref: "menu",
      staticClass: "swipe-menu d-md-none",
      class: { "swipe-menu--open": _vm.menuIsOpen },
    },
    [
      _c("div", {
        staticClass: "swipe-menu__background",
        on: { click: _vm.toggleMenu },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "swipe-menu__content" }, [
        _c("div", {
          staticClass: "swipe-menu__icon",
          on: { click: _vm.openMenu },
        }),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "p-0" },
          [
            _vm._l(_vm.list, function (item, index) {
              return [
                item.showItem
                  ? _c(
                      "li",
                      {
                        key: index,
                        on: {
                          click: function ($event) {
                            return _vm.handlerClick(item)
                          },
                        },
                      },
                      [
                        item.icon
                          ? _c("img", {
                              attrs: { src: _vm.assetsPathTheme(item.icon) },
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                    " +
                            _vm._s(item.name) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }